import { Users } from "lucide-react";
import { useServerStatus } from "@/context/ServerStatusContext";
import { StaffOnline } from "@/components/site/StaffOnline";
import { useText } from "@/lib/useText";

export function ServerStatus({ code }) {
  const status = useServerStatus();
  const t = useText();
  const dot = status.loading ? "bg-eden-muted" : status.online ? "bg-emerald-500 animate-pulseDot" : status.online === false ? "bg-red-500" : "bg-amber-500";
  const label = status.loading ? t("status_checking") : status.online ? t("status_online") : status.online === false ? t("status_offline") : t("status_unavailable");

  return (
    <div className="card-eden inline-flex w-full flex-col gap-4 p-5 sm:w-auto sm:min-w-[320px]" role="status" aria-live="polite" data-testid="server-status-card">
      <div className="flex items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <span className={`h-2.5 w-2.5 rounded-full ${dot}`} aria-hidden="true" />
          <span className="font-display text-sm font-semibold uppercase tracking-wider text-eden-text" data-testid="server-status-label">{label}</span>
        </div>
        <span className="font-mono text-xs uppercase tracking-widest text-eden-muted">FiveM</span>
      </div>
      {status.hostname && <p className="-mt-2 truncate text-xs text-eden-muted" title={status.hostname} data-testid="server-hostname">{status.hostname}</p>}
      <div className="hairline" />
      <div className="flex items-end justify-between gap-6">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-widest text-eden-muted">{t("status_players")}</p>
          <p className="mt-1 font-display text-3xl font-bold tabular-nums text-eden-text" data-testid="server-players">
            {status.online ? status.players : "0"}
            <span className="text-base font-medium text-eden-muted"> / {status.online && status.max_players ? status.max_players : "0"}</span>
          </p>
          {status.online && status.max_players > 0 && (
            <div className="mt-2 h-1 w-40 overflow-hidden rounded-full bg-eden-border" aria-hidden="true">
              <div className="h-full rounded-full bg-eden-orange transition-[width] duration-700" style={{ width: `${Math.min(100, Math.round((status.players / status.max_players) * 100))}%` }} />
            </div>
          )}
        </div>
        <div className="text-right">
          <p className="font-mono text-[11px] uppercase tracking-widest text-eden-muted">{t("status_code")}</p>
          <p className="mt-1 font-mono text-base text-eden-orange" data-testid="server-code">{code}</p>
        </div>
      </div>
      <StaffOnline />
      {status.error && !status.loading && (
        <p className="flex items-center gap-1.5 text-xs text-eden-muted" data-testid="server-status-error">
          <Users size={12} aria-hidden="true" /> {t("status_error")}
        </p>
      )}
    </div>
  );
}
